import type { GetStaticProps } from 'next'

import { NewtClient } from '@/utils/NewtClient'
import { WordPressApiClient } from '@/utils/WordPressApiClient'

import { NewsPage } from '@/components/pages/News'

import type { Blog } from '@/types/blog'
import type { NewsRelease } from '@/types/newsRelease'

type NewsProps = {
  newsRelease: readonly NewsRelease[]
  blogList: readonly Blog[]
}

const News = (props: NewsProps) => {
  return <NewsPage {...props} />
}

export const getStaticProps: GetStaticProps = async () => {
  const wpClient = new WordPressApiClient()
  const client = new NewtClient()
  const [newsRelease, pickUpBlog, blog] = await Promise.all([
    wpClient.fetchNewsRelease(3),
    client.fetchPickUpBlog(),
    client.fetchBlogList(2, false),
  ])

  const blogList = pickUpBlog ? [pickUpBlog, ...blog] : blog

  return {
    props: {
      newsRelease,
      blogList,
    },
  }
}

export default News
